import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

// Add Workshop
export const addWorkshop = createAsyncThunk("admin/addWorkshop", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/workshop/add`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// Get All Workshops
export const getWorkshops = createAsyncThunk("admin/allWorkshops", async ({ page, limit, searchData }, { rejectWithValue }) => {
  try {
    let url = `/workshop/all?`;
    if (page || limit) {
      url += `page=${page}&limit=${limit}`;
    }
    if (searchData) url += `&search=${searchData}`;
    const response = await apiInstance.get(url, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// Edit Workshop
export const editWorkshop = createAsyncThunk("admin/editWorkshop", async (payload, { rejectWithValue }) => {
  try {
    const response = await apiInstance.post(`/workshop/edit`, payload, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// Get Single Workshop
export const getSingleWorkshop = createAsyncThunk("admin/singleWorkshop", async (workshopId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.get(`/workshop/${workshopId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// Delete Workshop
export const deleteWorkshop = createAsyncThunk("admin/deleteWorkshop", async (selectedId, { rejectWithValue }) => {
  try {
    const response = await apiInstance.delete(`/workshop/delete/${selectedId}`, {
      headers: authHeader(),
    });
    return response;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const initialState = {
  workshopData: [],
  singleWorkshopData: [],
};

const workshopSlice = createSlice({
  name: "workshopSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWorkshops.fulfilled, (state, action) => {
      state.workshopData = action.payload.data;
    });
    builder.addCase(getSingleWorkshop.fulfilled, (state, action) => {
      state.singleWorkshopData = action.payload.data;
    });
  },
});

export default workshopSlice.reducer;
